import { Component } from '@angular/core';
import { DhofarSharedFooterComponent } from 'dhofar-shared-pkg';

@Component({
    selector: 'app-footer',
    imports: [DhofarSharedFooterComponent],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
